import { useParams, Link } from 'react-router-dom';
import { useBookingStatus } from '../api/booking';
import LoadingSpinner from '../components/common/LoadingSpinner';

export default function ConfirmationPage() {
  const { token } = useParams<{ token: string }>();
  const { data, isLoading } = useBookingStatus(token || '');

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <LoadingSpinner />
      </div>
    );
  }

  if (!data?.booking) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="text-center">
          <p className="text-gray-600">Keine Buchung gefunden.</p>
        </div>
      </div>
    );
  }

  const booking = data.booking;

  return (
    <div className="max-w-lg mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          {/* Success Icon */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg
              className="w-8 h-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Termin erfolgreich gebucht!
          </h1>
          <p className="text-gray-600 mb-8">
            Ihr Vorstellungsgespräch wurde bestätigt.
          </p>

          {/* Booking Details */}
          <div className="bg-gray-50 rounded-lg p-6 text-left space-y-4 mb-6">
            <div>
              <p className="text-sm text-gray-500">Datum & Uhrzeit</p>
              <p className="font-medium text-gray-900">
                {new Date(booking.scheduledStart).toLocaleDateString('de-DE', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
              <p className="text-gray-700">
                {new Date(booking.scheduledStart).toLocaleTimeString('de-DE', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}{' '}
                -{' '}
                {new Date(booking.scheduledEnd).toLocaleTimeString('de-DE', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </p>
            </div>

            <div>
              <p className="text-sm text-gray-500">Format</p>
              <p className="font-medium text-gray-900">Microsoft Teams Meeting</p>
            </div>
          </div>

          {/* Teams Link */}
          {booking.teamsJoinUrl && (
            <a
              href={booking.teamsJoinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 w-full px-4 py-3 bg-primary-600 text-white rounded-md hover:bg-primary-700 mb-4"
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M20.5 14.5v-8c0-.83-.67-1.5-1.5-1.5h-8c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5zm-3-6.5l2 1.5v5l-2 1.5v-8z" />
              </svg>
              Meeting beitreten
            </a>
          )}

          <Link
            to={`/status/${token}`}
            className="inline-block text-primary-600 hover:text-primary-700"
          >
            Termin verwalten
          </Link>
        </div>
    </div>
  );
}
